import React, { useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import './AddAccomodation.css';

const AddAccommodation = () => {
  const [accommodation, setAccommodation] = useState({ title: '', image: null, description: '' });
  const [imagePreview, setImagePreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleInputChange = (field, value) => {
    setAccommodation((prev) => ({ ...prev, [field]: value }));
  };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setAccommodation({ ...accommodation, image: file });
      
      // Create preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
  
    const formData = new FormData();
    formData.append('title', accommodation.title);
    formData.append('description', accommodation.description);
    formData.append('image', accommodation.image);
  
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_SERVER_URL}/api/v1/admin/add-accommodation`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      setLoading(false);
      console.log(response.data);

      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Accommodation added successfully!',
        confirmButtonColor: '#5e71f6',
      });

      navigate('/admin/remove-accomodation');
      
      setAccommodation({ title: '', image: null, description: '' });
      setImagePreview(null);
    } catch (error) {
      setLoading(false);
      console.error('Error submitting accommodation:', error.response?.data);

      Swal.fire({
        icon: 'error',
        title: 'Failed!',
        text: 'Failed to add accommodation details.',
        confirmButtonColor: '#5e71f6',
      });
    }
  };

  return (
    <div className="add-accommodation-wrapper">
      <div className="add-accommodation-container">
        <div className="header-section">
          <h1 className="page-title">Add Accommodation</h1>
          <p className="page-subtitle">Add new accommodation details for conference attendees</p>
        </div>

        <form onSubmit={handleSubmit} className="accommodation-form">
          {/* Title */}
          <div className="form-group">
            <label htmlFor="title" className="form-label">
              Title <span className="required">*</span>
            </label>
            <input
              type="text"
              id="title"
              value={accommodation.title}
              onChange={(e) => handleInputChange('title', e.target.value)}
              required
              placeholder="Enter accommodation title (e.g., Hotel Royal Plaza)"
              className="form-input"
            />
          </div>

          {/* Description */}
          <div className="form-group">
            <label htmlFor="description" className="form-label">
              Description <span className="required">*</span>
            </label>
            <textarea
              id="description"
              value={accommodation.description}
              onChange={(e) => handleInputChange('description', e.target.value)}
              rows="6"
              required
              placeholder="Enter accommodation description, facilities, and other details..."
              className="form-textarea"
            />
          </div>

          {/* Image Upload */}
          <div className="image-upload-card">
            <label className="form-label">
              Upload Image <span className="required">*</span>
            </label>
            <div className="image-upload-area">
              <input
                type="file"
                id="image-upload"
                onChange={handleImageChange}
                accept="image/*"
                required
                className="image-input"
              />
              <label htmlFor="image-upload" className="image-upload-label">
                {imagePreview ? (
                  <div className="image-preview-container">
                    <img src={imagePreview} alt="Preview" className="image-preview" />
                    <div className="image-overlay">
                      <svg className="upload-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      <span className="change-text">Click to change image</span>
                    </div>
                  </div>
                ) : (
                  <>
                    <svg className="upload-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                    </svg>
                    <span className="upload-text">Click to upload or drag and drop</span>
                    <span className="upload-hint">PNG, JPG, JPEG (MAX. 5MB)</span>
                  </>
                )}
              </label>
            </div>
          </div>

          {/* Submit Button */}
          <button type="submit" disabled={loading} className="submit-btn">
            {loading ? (
              <>
                <div className="loading-spinner-small"></div>
                Adding Accommodation...
              </>
            ) : (
              <>
                <svg className="btn-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Add Accommodation
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddAccommodation;
